import type { PaymentsState } from '@common/Checkout/Checkout/types';
import type { PaymentsReducer } from '@common/Checkout/Checkout/types/reducers';
import { RECEIVE_PAYMENT_LIST_DATA, RESET_PAYMENT_LIST_DATA } from '../actions/constants';

const initialState: PaymentsState = {
    payments: [],
    collapsable: false,
    isCollapsed: false,
    collapseLimit: null,
    isLoaded: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: PaymentsReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case RECEIVE_PAYMENT_LIST_DATA: {
            const { payload } = action;

            return { isLoaded: true, ...payload };
        }

        case RESET_PAYMENT_LIST_DATA: {
            return { ...initialState };
        }

        default:
            return state;
    }
};

export default reducer;
